import { green, purple, orange, red } from "@material-ui/core/colors";

export const Colors = {
  green: {
    ...green,
    500: "#09804C",
    A400: "#B9EACD",
  },
  purple: {
    ...purple,
    500: "#6200EE",
    A400: "#9795F9",
  },
  orange,
  red,
};
